import _toConsumableArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import { useMemo, useRef, useState, useCallback, useEffect } from 'react';
import AliceCarousel from 'react-alice-carousel';
import debounce from 'lodash.debounce';
import { filterIconMap } from '@restworld/utils-common';
import { useActiveIndex } from '../../design-system';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function JobExplorerQuickFilters(_ref) {
  var onQuickFilterChange = _ref.onQuickFilterChange,
      activeQuickFilters = _ref.activeQuickFilters,
      isDisabled = _ref.isDisabled,
      quickFilterItems = _ref.quickFilterItems;

  var _useState = useState([]),
      actives = _useState[0],
      setActive = _useState[1];

  var _useActiveIndex = useActiveIndex(),
      activeIndex = _useActiveIndex.activeIndex,
      onSlideChanged = _useActiveIndex.onSlideChanged;

  var carouselRef = useRef(null);
  var handleClick = useCallback(function (e, id, index) {
    e.preventDefault();
    setActive(function (p) {
      var activeIndexes = _toConsumableArray(p).includes(id) ? _toConsumableArray(p).filter(function (v) {
        return v !== id;
      }) : [].concat(_toConsumableArray(p), [id]);
      onQuickFilterChange(activeIndexes);
      return activeIndexes;
    });
    onSlideChanged(index);
  }, [onQuickFilterChange, onSlideChanged]);
  var items = useMemo(function () {
    return quickFilterItems.map(function (_ref2, index) {
      var id = _ref2.id,
          label = _ref2.label,
          icon = _ref2.icon;
      var Icon = filterIconMap[icon];
      var isActive = actives.includes(id);
      return /*#__PURE__*/_jsxs(FilterItem, {
        isActive: isActive,
        isDisabled: isDisabled,
        href: "#!",
        onClick: debounce(function (e) {
          return handleClick(e, id, index);
        }, 150),
        children: [Icon ? /*#__PURE__*/_jsx(IconWrapper, {
          isActive: isActive,
          children: /*#__PURE__*/_jsx(Icon, {
            size: 24,
            stroke: isDisabled ? "#9CA3AF" : isActive ? "#ffffff" : "#1C1327"
          })
        }) : null, /*#__PURE__*/_jsx(LabelEl, {
          isActive: isActive,
          isDisabled: isDisabled,
          children: label
        })]
      }, label);
    });
  }, [actives, handleClick, isDisabled, quickFilterItems]);
  useEffect(function () {
    if (activeQuickFilters) {
      setActive(activeQuickFilters);
    }
  }, [onSlideChanged, activeQuickFilters]);
  return /*#__PURE__*/_jsx(Wrapper, {
    children: /*#__PURE__*/_jsx(AliceCarousel, {
      mouseTracking: true,
      disableButtonsControls: true,
      disableDotsControls: true,
      keyboardNavigation: false,
      touchTracking: true,
      ref: carouselRef,
      items: items,
      autoWidth: true,
      activeIndex: activeIndex,
      paddingRight: 32
    })
  });
}
export default JobExplorerQuickFilters;

var FilterItem = /*#__PURE__*/_styled.a.withConfig({
  displayName: "job-explorer-quick-filters__FilterItem",
  componentId: "sc-vawz7v-0"
})(["", ";", " ", ""], {
  "display": "flex",
  "maxHeight": "40px",
  "width": "fit-content",
  "flexDirection": "row",
  "alignItems": "center",
  "gap": "0.25rem",
  "borderRadius": "8px",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(209 213 219 / var(--tw-border-opacity))",
  "paddingLeft": "0.75rem",
  "paddingRight": "0.75rem",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem"
}, function (_ref3) {
  var isDisabled = _ref3.isDisabled;
  return isDisabled ? {
    "pointerEvents": "none",
    "cursor": "not-allowed"
  } : {};
}, function (_ref4) {
  var isActive = _ref4.isActive;
  return isActive ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(105 62 181 / var(--tw-bg-opacity))"
  } : {};
});

var Wrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-explorer-quick-filters__Wrapper",
  componentId: "sc-vawz7v-1"
})({
  "position": "relative",
  "width": "100%",
  "overflow": "hidden"
});

var LabelEl = /*#__PURE__*/_styled.h5.withConfig({
  displayName: "job-explorer-quick-filters__LabelEl",
  componentId: "sc-vawz7v-2"
})(["", ";", " ", ""], {
  "cursor": "pointer",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(75 85 99 / var(--tw-text-opacity))"
}, function (_ref5) {
  var isActive = _ref5.isActive;
  return isActive ? {
    "fontWeight": "600",
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  } : {};
}, function (_ref6) {
  var isDisabled = _ref6.isDisabled;
  return isDisabled ? {
    "--tw-text-opacity": "1",
    "color": "rgb(156 163 175 / var(--tw-text-opacity))"
  } : {};
});

var IconWrapper = /*#__PURE__*/_styled.span.withConfig({
  displayName: "job-explorer-quick-filters__IconWrapper",
  componentId: "sc-vawz7v-3"
})(["", ";"], {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center",
  "borderRadius": "0.5rem"
});